export const ContactsTableColumns = [
    {
        id: 'name',
        labelAr: 'الاسم',
        labelEn: 'Name',
        align: 'left',
    },
    {
        id: 'email',
        labelAr: 'البريد الإلكتروني',
        labelEn: 'Email',
        align: 'left',
    },
    {
        id: 'subject',
        labelAr: 'الموضوع',
        labelEn: 'Subject',
        align: 'left',
    },
    {
        id: 'is_read',
        labelAr: 'الحالة',
        labelEn: 'Status',
        align: 'center',
    },
    {
        id: 'created_at',
        labelAr: 'تاريخ الإرسال',
        labelEn: 'Sent At',
        align: 'center',
    },
];
